var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2311_28249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9551 24.0002H47.9985C47.9985 21.834 47.7098 19.7355 47.1717 17.7393H22.9551V24.0002Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9551 11.4772H44.476C43.0068 9.07984 41.1283 6.96081 38.9381 5.21631H22.9551V11.4772Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 48.0001C29.6485 48.0001 34.8401 46.0478 38.9398 42.7827H9.06055C13.1602 46.0478 18.3518 48.0001 24.0002 48.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52195 36.5202H44.4768C45.6563 34.5956 46.571 32.4918 47.1726 30.2593H0.826172C1.42777 32.4918 2.34248 34.5956 3.52195 36.5202Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 3.74794H13.3043L11.27 5.22591L12.0471 7.61737L10.0128 6.13941L7.9785 7.61737L8.64975 5.55141C6.85856 7.04344 5.28862 8.7915 3.99487 10.7393H4.69566L3.40069 11.68C3.19894 12.0166 3.00544 12.3585 2.82 12.7055L3.43837 14.6087L2.28469 13.7705C1.99791 14.3781 1.73559 14.9993 1.49981 15.6336L2.18109 17.7306H4.69566L2.66128 19.2085L3.43837 21.6L1.40409 20.122L0.185531 21.0074C0.0635625 21.9878 0 22.9865 0 24H24C24 10.7452 24 9.18262 24 0C19.2589 0 14.8392 1.37531 11.1172 3.74794ZM12.0471 21.6L10.0128 20.122L7.9785 21.6L8.75559 19.2085L6.72122 17.7306H9.23578L10.0128 15.3391L10.7898 17.7306H13.3043L11.27 19.2085L12.0471 21.6ZM11.27 12.2172L12.0471 14.6087L10.0128 13.1307L7.9785 14.6087L8.75559 12.2172L6.72122 10.7393H9.23578L10.0128 8.34778L10.7898 10.7393H13.3043L11.27 12.2172ZM20.6558 21.6L18.6215 20.122L16.5872 21.6L17.3643 19.2085L15.3299 17.7306H17.8445L18.6215 15.3391L19.3985 17.7306H21.913L19.8787 19.2085L20.6558 21.6ZM19.8787 12.2172L20.6558 14.6087L18.6215 13.1307L16.5872 14.6087L17.3643 12.2172L15.3299 10.7393H17.8445L18.6215 8.34778L19.3985 10.7393H21.913L19.8787 12.2172ZM19.8787 5.22591L20.6558 7.61737L18.6215 6.13941L16.5872 7.61737L17.3643 5.22591L15.3299 3.74794H17.8445L18.6215 1.35647L19.3985 3.74794H21.913L19.8787 5.22591Z",
    fill: "#1943DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2311_28249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.e22102cb7932eea47bf28aff282cf769.svg";
export { ForwardRef as ReactComponent };